import type { FC } from "react";
import "@web/src/styles/landing.scss";
import TodayIcon from "@web/public/to-day.svg";

interface TermsPageProps {}

const TermsPage: FC<TermsPageProps> = ({}) => {
  return (
    <main>
      <header className="flex flex-row gap-4 items-center">
        <TodayIcon className="w-7 h-7" />
        <h1>Terms Of Use</h1>
      </header>
      <div>
        <h2>1. Definitions</h2>
        <ul>
          <li>
            <strong>User</strong> - any individual using To-day, registered or not registered on the platform.
          </li>
          <li>
            <strong>Service</strong> - To-day, the application and any other services or content provided by To-day
          </li>
          <li>
            <strong>Content</strong> - any content created by or for a User
          </li>
          <li>
            <strong>Third-Party Providers</strong> - any third-party providers of services or content
          </li>
        </ul>
        <h2>2. Provision of Software</h2>
        <p>
          To-day shall make the itself available to Users pursuant to these Terms. User’s purchase of To-day plans are
          not contingent upon the delivery of any future functionality or features, or dependent on any oral or written
          public comments made by To-day regarding future functionality or features.
        </p>
        <h2>3. To-day Responsibilities</h2>
        <p>
          The Services evolve constantly. As such, the Services may change from time to time, at our discretion. We may
          stop (permanently or temporarily) providing the Services or any features within the Services to you or to
          users generally. We also retain the right to create limits on use and storage at our sole discretion at any
          time.
          <br />
          <br />
          To-day shall use commercially reasonable efforts to make the To-day available 24 hours a day, seven days a
          week, except for: (i) planned downtime; or (ii) any unavailability caused by circumstances beyond To-day’s
          reasonable control, including without limitation, any event of force majeure, acts of nature, acts of
          government, fire, civil unrest, acts of terror, earthquakes, pandemic, epidemic, strikes, internet service
          provider, Third-Party Providers, hosting providers, failures or delays involving hardware, software or power
          systems not within To-day’s possession or reasonable control, and denial of service attacks; (iii) the event
          that To-day is unable to provide the Services due to a lack of resources or other circumstances beyond
          To-day’s reasonable control; (iv) provide the Services in compliance with applicable laws except to the extent
          any breach of the Terms by User causes To-day to be in violation of applicable law.
          <br />
          <br />
          To-day is a startup company. We may suspend or terminate your access to the Services at any time, with or
          without cause, with or without notice, effective immediately. We may also, in our sole discretion, restrict or
          terminate your access to the Services at any time, with or without cause, with or without notice, effective
          immediately.
        </p>
        <h2>4. User Responsibilities</h2>
        <p>The User is responsible for all actions taken by the User in compliance with this Agreement.</p>
        <ul>
          <li>
            User shall use the Services in a manner consistent with the Terms of Use and other applicable laws and
            regulations.
          </li>
          <li>User shall not use the Services for any illegal or unauthorized purpose.</li>
          <li>User shall not use the Services to violate any applicable laws or regulations.</li>
          <li>
            User shall not use the Services to harass, abuse, threaten, stalk, defame, or otherwise violate the legal
            rights (including but not limited to copyright, trademark, privacy, and publicity) of others.
          </li>
          <li>
            User shall not use the Services to impersonate another person or falsely state or otherwise misrepresent
            that person’s identity or affiliation.
          </li>
          <li>
            User shall not use the Services to engage in any activity that interferes with the Services or violates the
            Terms of Use.
          </li>
          <li>
            User shall not use the Services to violate any applicable laws or regulations, including but not limited to
            those relating to child pornography, obscenity, gambling, adult content, or the promotion of violence.
          </li>
          <li>
            User shall not use the Services to collect or solicit personal information from others without their
            consent.
          </li>
        </ul>
        <h2>5. User Content</h2>
        <p>
          You are responsible for your use of the Services and for any Content you provide, including compliance with
          applicable laws, rules, and regulations. You should only provide Content that you are comfortable sharing with
          others. Any use or reliance on any Content or materials posted via the Services or obtained by you through the
          Services is at your own risk. You understand that by using the Services collaboratively, you may be exposed to
          Content created by other Users that might be offensive, harmful, inaccurate or otherwise inappropriate, or in
          some cases, postings that have been mislabeled or are otherwise deceptive. All Content is the sole
          responsibility of the person who originated such Content. We may not monitor or control the Content posted via
          the Services and, we cannot take responsibility for such Content.
        </p>
        <h2>6. Disclaimers and Limitations of Liability</h2>
        <p>
          To-day is provided on an “as is” and “as available” basis without any warranties of any kind, either express
          or implied, including, without limitation, implied warranties of merchantability, fitness for a particular
          purpose, or non-infringement. To-day does not warrant that the Services will meet your requirements or that
          the operation of the Services will be uninterrupted or error-free, or that any errors or defects will be
          corrected. You understand that To-day may make changes to the Services at any time without notice. To-day does
          not make any commitment to update the Services, and we have no liability whatsoever for any delay or failure
          to update the Services. You acknowledge and agree that To-day shall not be responsible for any loss or damage
          of any nature incurred as a result of the failure to update the Services. To-day does not guarantee the
          Services will be available at all times. To-day does not guarantee that the Services will be error-free or
          uninterrupted, or that any errors or defects will be corrected. You acknowledge and agree that To-day shall
          not be responsible for any loss or damage of any nature incurred as a result of the failure to update the
          Services.
          <br />
          <br />
          To the fullest extent permitted by applicable law, in no event shall To-day or its suppliers be liable to you
          or any third party for any indirect, incidental, special, consequential, or punitive damages, including but
          not limited to damages for loss of profits, goodwill, use, data, or other intangible losses, arising out of or
          in connection with your use of or inability to use the Services, even if To-day or a To-day authorized
          representative has been advised of the possibility of such damages. To-day’s liability to you for any claim
          arising out of or in connection with your use of the Services shall be limited to the amount you have paid to
          To-day for the Services. To-day shall not be liable for any delay or failure in performance resulting from
          causes beyond To-day’s reasonable control. In no event shall To-day’s total aggregate liability to you for all
          claims in connection with the Services exceed the amount To-day paid by you for the Services.
          <br />
          <br />
          You agree to indemnify and hold To-day and its officers, directors, employees, and agents, harmless from and
          against any and all claims, liabilities, damages, losses, and expenses, including reasonable attorneys’ fees,
          arising out of or in connection with your use of the Services, including but not limited to your violation of
          these Terms.
        </p>
        <h2>7. Changes to the Terms of Use</h2>
        <p>
          We reserve the right to update or change the Terms of Use from time to time. We encourage you to review this
          Agreement frequently to stay informed about how we are protecting your personal information.
        </p>
        <h2>8. Contact Us</h2>
        <p>
          If you have any questions about the Terms of Use, please contact me at <a>moosedevapps@gmail.com</a> or dm me
          on Instagram <a href="https://www.instagram.com/moosedevapps/">@moosedevapps</a>.
          <br />
          <br />
          Last updated: November 2024 <br />
          Effective date: November 2024
        </p>
      </div>
    </main>
  );
};

export default TermsPage;
